import { z } from 'zod';

import { CreateLoanRow } from '@willow/types-iso';

import { getParsedFields } from '../CreateLoanCrossFieldParser';

export const validateArmFields = (data: CreateLoanRow, ctx: z.RefinementCtx) => {
  const parsed = getParsedFields(data, [
    'loanType',
    'amortizationType',
    'armIndex',
    'armMarginPercent',
    'armMarginDecimal',
    'armRateAdjustmentFrequency',
    'armFixedTermMonths',
    'armFirstRateChangeDate',
    'armMaxIncreasePerPeriodPercent',
    'armMaxIncreasePerPeriodDecimal',
    'armMinIncreasePerPeriodPercent',
    'armMinIncreasePerPeriodDecimal',
    'armMaxIncreaseForFirstPeriodPercent',
    'armMaxIncreaseForFirstPeriodDecimal',
    'armMinIncreaseForFirstPeriodPercent',
    'armMinIncreaseForFirstPeriodDecimal',
    'interestOnlyFlag',
  ]);
  if (!parsed || (parsed.amortizationType !== 'arm' && parsed.loanType !== 'arm')) return;

  const {
    armIndex,
    armMarginPercent,
    armMarginDecimal,
    armRateAdjustmentFrequency,
    armFixedTermMonths,
    armFirstRateChangeDate,
    armMaxIncreasePerPeriodDecimal,
    armMaxIncreasePerPeriodPercent,
    armMinIncreasePerPeriodPercent,
    armMinIncreasePerPeriodDecimal,
    armMaxIncreaseForFirstPeriodPercent,
    armMaxIncreaseForFirstPeriodDecimal,
    armMinIncreaseForFirstPeriodPercent,
    armMinIncreaseForFirstPeriodDecimal,
    interestOnlyFlag,
  } = parsed;

  if (armIndex == null) {
    ctx.addIssue({
      code: 'custom',
      message: 'Missing required field for ARM: armIndex.',
    });
  }

  if (armRateAdjustmentFrequency == null) {
    ctx.addIssue({
      code: 'custom',
      message: 'Missing required field for ARM: armRateAdjustmentFrequency.',
    });
  }

  if (armMarginPercent == null && armMarginDecimal == null) {
    ctx.addIssue({
      code: 'custom',
      message: 'Missing the margin for ARM. Please provide either armMarginPercent or armMarginDecimal.',
    });
  }

  if (armFixedTermMonths == null && armFirstRateChangeDate == null) {
    ctx.addIssue({
      code: 'custom',
      message:
        'Missing the first effective change date for ARM. Please provide either armFixedTermMonths or armFirstRateChangeDate.',
    });
  }

  if (armFirstRateChangeDate == null && armFixedTermMonths === 0 && !interestOnlyFlag) {
    ctx.addIssue({
      code: 'custom',
      message: 'Invalid value of 0 for armFixedTermMonths.',
    });
  }

  if (
    armMinIncreaseForFirstPeriodPercent &&
    armMaxIncreaseForFirstPeriodPercent &&
    armMinIncreaseForFirstPeriodPercent > armMaxIncreaseForFirstPeriodPercent
  ) {
    ctx.addIssue({
      code: 'custom',
      message: 'armMinIncreaseForFirstPeriodPercent cannot be greater than armMaxIncreaseForFirstPeriodPercent',
    });
  }

  if (
    armMinIncreaseForFirstPeriodDecimal &&
    armMaxIncreaseForFirstPeriodDecimal &&
    armMinIncreaseForFirstPeriodDecimal > armMaxIncreaseForFirstPeriodDecimal
  ) {
    ctx.addIssue({
      code: 'custom',
      message: 'armMinIncreaseForFirstPeriodDecimal cannot be greater than armMaxIncreaseForFirstPeriodDecimal',
    });
  }

  if (
    armMinIncreasePerPeriodPercent &&
    armMaxIncreasePerPeriodPercent &&
    armMinIncreasePerPeriodPercent > armMaxIncreasePerPeriodPercent
  ) {
    ctx.addIssue({
      code: 'custom',
      message: 'armMinIncreasePerPeriodPercent cannot be greater than armMaxIncreasePerPeriodPercent',
    });
  }

  if (
    armMinIncreasePerPeriodDecimal &&
    armMaxIncreasePerPeriodDecimal &&
    armMinIncreasePerPeriodDecimal > armMaxIncreasePerPeriodDecimal
  ) {
    ctx.addIssue({
      code: 'custom',
      message: 'armMinIncreasePerPeriodDecimal cannot be greater than armMaxIncreasePerPeriodDecimal',
    });
  }
};
